module.exports = __webpack_public_path__ + "img/klarna-sofort-alt.1a8174f1.png";